module.exports = __webpack_public_path__ + "img/JJ-signup.231e07a4.png";